import { Box, TextField, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

export const ListFilterToolbar = ({
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search...',
  searchLabel = 'Search',
  resultCount = null,
  rightContent = null,
  sx = {},
}) => {
  return (
    <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, ...sx }}>
      <TextField
        size="small"
        label={searchLabel}
        placeholder={searchPlaceholder}
        value={searchValue}
        onChange={(e) => onSearchChange?.(e.target.value)}
        sx={{ minWidth: { xs: 0, sm: 240 }, width: '100%', flex: { xs: '1 1 100%', sm: '1 1 240px' } }}
        slotProps={{
          input: {
            startAdornment: (
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 1, color: 'text.secondary' }}>
                <SearchIcon fontSize="small" />
              </Box>
            ),
          },
        }}
      />
      {typeof resultCount === 'number' ? (
        <Typography variant="body2" color="text.secondary">
          {resultCount} result{resultCount !== 1 ? 's' : ''}
        </Typography>
      ) : null}
      {rightContent}
    </Box>
  )
}
